<template>
  <label class="switch">
    <input
      v-if="
        isActive === true
        || isActive === 1
      "
      type="checkbox" 
      checked
      v-model="inputVal"
    />
    
    <input
      v-else
      type="checkbox"
      v-model="inputVal"
      v-on:input="$emit('handleInput')"
    />
    
    <span class="switch--slider"></span>
  </label>
</template>

<script>
  export default {
    name: 'SwitchForm',
    props: [
      'isActive'
    ],
    data() {
      return { inputVal: this.isActive }
    },
    watch: {
      inputVal(val) {
        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="scss">
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 20px;

  input { 
    opacity: 0;
    width: 0;
    height: 0;
  }

  &--slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    margin-bottom: 0 !important;
  }

  &--slider:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
  }

  input:checked + &--slider {
    background-color: var(--blue);
  }

  input:focus + &--slider {
    box-shadow: 0 0 1px var(--blue);
  }

  input:checked + &--slider:before {
    -webkit-transform: translateX(10px);
    -ms-transform: translateX(10px);
    transform: translateX(10px);
    border-radius: 50%;
  }
}
</style>